import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VMdDateRangePicker from "v-md-date-range-picker";
import VueVideoPlayer from 'vue-video-player'
import ImageUploader from 'vue-image-upload-resize'
// require videojs style
import 'video.js/dist/video-js.css'
import VCalendar from "v-calendar";
import store from "./store";
import interceptors from "./services/interceptors";
import { i18n } from "./plugins/i18n";
import vClickOutside from 'v-click-outside'
 
interceptors.check401Error();
interceptors.globalErrorHandling();
interceptors.checkExpiredToken();
interceptors.setBearerToken();

Vue.use(vClickOutside)
Vue.use(VMdDateRangePicker);
Vue.use(ImageUploader);
Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  locale:'nl-NL',
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

/* Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
}); */